<template>
  <div class="kurir">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:flex-col mdmax:shadow-none">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2">
        <LinkButton buttonText="Tambah Kurir" url="/kurir/create" linkType="internal" :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex justify-end gap-8 mdmax:flex-col mdmax:flex-auto mdmax:w-full mdmax:gap-2">
        <div class="w-2/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Cabang</label>
          <CustomSelect :options="cities" optionLabel="name" v-model="selectedType" />
        </div>
        <div class="w-3/5 mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Pencarian nama, no hp, cabang. area" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableComponent :columns="columns" :list="courier">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/kurir/detail/${entry.id}`" linkType="internal" type="secondary" size="small" />
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    typeList: ['Semua', 'Pickup', 'Pengiriman'],
    selectedType: '',
    columns: [
      // { label: 'ID', field: 'id' },
      { label: 'Nama', field: 'name' },
      { label: 'No Handphone', field: 'phone_number' },
      { label: 'Area', field: 'area_name' },
      { label: 'Status', field: 'availability_status' },
      { label: 'Action', field: 'action' }
    ],
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('auth', ['userData']),
    ...mapGetters('courier', ['courier']),
    ...mapGetters('master', ['cities']),
    filteredData() {
      let temp = this.courier || []
      temp = temp.filter((item) => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  created() {
    this.getCityList()
    if (!this.$route.query.page) {
      this.$router.push({ path: '/kurir', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getCourierList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getCourierList()
      } else {
        this.$router.push({ path: '/kurir', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('courier', ['getCourier']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('master', ['getCities']),
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    getCourierList(searchTerm = '') {
      this.showLoading()
      this.getCourier({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      })
        .then((res) => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/kurir', query: { page: page } })
    },
    doSearch() {
      this.getCourierList(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/kurir', query: { page: page } })
      this.page = page
      this.currentPage = page
    },
    goToDetail(target) {
      this.$router.push(`/kurir/detail/${target}`)
    }
  }
}
</script>
